import React, { useEffect, useState } from "react";
import {
  BackButton,
  Box,
  ButtonStyled,
  SubHeadingStyled,
} from "../../../components/styled/Elements";
import { DashboardWrapper } from "./styled";
import {
  PlaceholderImg,
  SearchIcon,
} from "../../../components/styled/AllImages";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import AdvancedSearchModal from "../../../components/common/modals/dataModels/AdvancedSearchModal";
import { useTranslation } from "react-i18next";
import DashboardView from "./components/DashboardView";
import DashboardApi from "../../../services/api/dashboardApi";
import { useDebounce } from "../../../hooks/useDebounce";
import SearchResults from "./components/SearchResults";
import { useUser } from "../../../context/userContext";
import { toast } from "react-toastify";

const Dashboard = () => {
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;
  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const [hasSearchResults, setHasSearchResults] = useState(false);
  const [showAdvancedSearchModal, setShowAdvancedSearchModal] = useState(false);
  const [searchParams, setSearchParams] = useState({
    search_name: "",
    search_archive_type: "",
    search_date: "",
    search_status: "",
    limit: "",
  });

  // Cabinets
  const [cabinetsData, setCabinetsData] = useState([]);

  // Archives
  const [archivesData, setArchivesData] = useState([]);

  // Files
  const [filesData, setFilesData] = useState([]);

  const {
    t,
    i18n: { language },
  } = useTranslation();

  const handleChange = async (e) => {
    let { name, value } = e.target;
    setSearchParams((prevVals) => ({
      ...prevVals,
      [name]: value,
    }));
  };

  const handleSearch = async (page, searchValues) => {
    try {
      setLoading(true);
      const { data, code, message } =
        await DashboardApi.getAdvanceSearchResults(page, searchValues);
      if (code === 200) {
        const processOwnerUser = (item) => ({
          ...item,
          owner_user: {
            ...item?.owner_user,
            name:
              parseInt(user?.id) === parseInt(item?.owner_user?.id)
                ? "myself"
                : item?.owner_user?.name,
            profile: item?.owner_user?.profile
              ? `${ASSET_URL}/${item?.owner_user?.profile}`
              : PlaceholderImg,
            subLabel:
              item?.owner_user?.user_detail?.department_selective &&
              item?.owner_user?.user_detail?.office_location_selective
                ? language === "en"
                  ? `${item?.owner_user?.user_detail?.department_selective?.name_en} (${item?.owner_user?.user_detail?.office_location_selective?.name_en})`
                  : `${item?.owner_user?.user_detail?.department_selective?.name_ar} (${item?.owner_user?.user_detail?.office_location_selective?.name_ar})`
                : "",
          },
          profile: item?.owner_user?.profile
            ? `${ASSET_URL}/${item?.owner_user?.profile}`
            : PlaceholderImg,
        });
        setHasSearchResults(true);

        // setCabinetsData(data.cabinets?.map(processOwnerUser) || []);
        // setFilesData(data.files?.map(processOwnerUser) || []);

        setArchivesData(data.archives?.map(processOwnerUser) || []);
      } else {
        setHasSearchResults(true);

        setCabinetsData([]);

        setArchivesData([]);

        setFilesData([]);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardWrapper>
      <Box className="content-head">
        {hasSearchResults ? (
          <BackButton
            label={t("search_results")}
            onClick={() => {
              setHasSearchResults(false);
              setCabinetsData([]);

              setArchivesData([]);

              setFilesData([]);
            }}
          />
        ) : (
          <SubHeadingStyled size="16px" weight="700" color="var(--text)">
            {t("dashboard")}
          </SubHeadingStyled>
        )}
        <Box className="advanced-search-wrapper">
          <FloatingInput
            width="40vw"
            height="41px !important"
            name="search_name"
            type="input"
            fieldType="text"
            label={t("search")}
            placeholder={t("search_all")}
            icon={SearchIcon}
            onChange={handleChange}
          />
          <ButtonStyled
            label={t("search")}
            disabled={!searchParams?.search_name}
            onClick={() => handleSearch(1, searchParams)}
          />
          <ButtonStyled
            weight="600"
            color="var(--text)"
            size="14px"
            className="py-2 advanced-search-btn"
            label={t("advanced_search")}
            onClick={() => setShowAdvancedSearchModal(true)}
          />
        </Box>
      </Box>
      {hasSearchResults ? (
        <SearchResults
          loading={loading}
          // cabinetsData={cabinetsData}
          // filesData={filesData}
          archivesData={archivesData}
          getCabinetsList={handleSearch}
          searchParams={searchParams}
        />
      ) : (
        <DashboardView />
      )}

      <AdvancedSearchModal
        show={showAdvancedSearchModal}
        onHide={() => setShowAdvancedSearchModal(false)}
        onChange={setSearchParams}
        onSearch={handleSearch}
      />
    </DashboardWrapper>
  );
};

export default Dashboard;
